export default __webpack_public_path__ + "static/media/Compare-inactive.141ee3d5.svg";